import React, {FC, useEffect, useRef, useState} from 'react';
import css from "./InfoAccordion.module.scss";
import Collapse from "@kunukn/react-collapse";
import TextBlocks from "../TextBlocks/TextBlocks";
import {AccordionElement} from "entities/accordion-element";
import HTMLReactParser from 'html-react-parser';

const anchorIdMap: Record<string, string> = {
    "інформаційних систем та технологій": "dep21",
    "комп'ютерних наук та інтелектуальних технологій": "dep22",
    "технічного забезпечення": "dep23",
    "комунікаційних систем та мереж": "dep11",
    "радіотехнологій": "dep12",
    "електроніки та схемотехніки": "dep13",
    "захисту інформації в інформаційно-комунікаційних системах": "dep31",
    "спеціальних інформаційних систем та робототехнічних комплексів": "dep32",
    "кібербезпеки": "dep33",
    "бойового застосування підрозділів зв'язку": "dep41",
    "тактики та вогневої підготовки": "dep42",
    "бойового забезпечення та повсякденної діяльності": "dep43",
    "соціально-гуманітарних дисциплін": "dep44",
    "фізичного виховання, спеціальної фізичної підготовки і спорту": "dep45",
};

const normalizeQuotes = (str: string): string =>
    str.replace(/[\u2018\u2019\u02BC]/g, "'").replace(/[\u201C\u201D]/g, '"');

const getAnchorId = (title: string): string | undefined => {
    const stripped = normalizeQuotes(title.replace(/<[^>]*>/g, '').toLowerCase());
    for (const [key, id] of Object.entries(anchorIdMap)) {
        if (stripped.includes(key)) return id;
    }
    return undefined;
};

interface InfoAccordion {
    item: AccordionElement
}

const InfoAccordion: FC<InfoAccordion> = ({item}) => {
    const anchorId = getAnchorId(item.title);
    const hash = window.location.hash.replace('#', '');
    const [isOpen, setsOpen] = useState(anchorId ? hash === anchorId : false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (anchorId && hash === anchorId && containerRef.current) {
            const scrollToElement = () => {
                const chiefCard = containerRef.current?.querySelector('[class*="chiefCard__"]') as HTMLElement | null;
                if (chiefCard) {
                    chiefCard.scrollIntoView({behavior: 'smooth', block: 'center'});
                } else {
                    containerRef.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
            };
            setTimeout(scrollToElement, 500);
            window.addEventListener('load', () => setTimeout(scrollToElement, 300), {once: true});
        }
    }, []);

    const toggle = () => {
        setsOpen(!isOpen)
    }
    return (
        <div className={css.container} id={anchorId} ref={containerRef}>
            <div onClick={toggle} className={css.toggleContainer}>
                <p className={css.toggleTitle}>{HTMLReactParser(item.title)}</p>
                <button className={`${css.toggleBtn} ${isOpen && css.toggleBtn_active}`}>
                    <i className="bi bi-caret-left"></i>
                </button>
            </div>
            <Collapse className={css.collapse} transition="height 300ms cubic-bezier(.4, 0, .2, 1)" isOpen={isOpen}
                      render={() => (
                          <TextBlocks textBlocks={item.textBlocks}/>
                      )}>
            </Collapse>
        </div>
    );
};

export default InfoAccordion;